'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = ReservationDetails;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _LocaleUtils = require('@wix/wixrest-utils/dist/LocaleUtils');

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _DefaultElement = require('oy-vey/lib/components/DefaultElement.js');

var _DefaultElement2 = _interopRequireDefault(_DefaultElement);

var _ReservationDetails = require('./ReservationDetails.style');

var _ReservationDetails2 = _interopRequireDefault(_ReservationDetails);

var _colors = require('../utils/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = _DefaultElement2.default.Table,
    TBody = _DefaultElement2.default.TBody,
    TR = _DefaultElement2.default.TR,
    TD = _DefaultElement2.default.TD;
function ReservationDetails(_ref) {
    var i18n = _ref.i18n,
        reservation = _ref.reservation,
        restaurant = _ref.restaurant,
        fontFamily = _ref.fontFamily,
        titleFontFamily = _ref.titleFontFamily,
        titlePaddingBottom = _ref.titlePaddingBottom,
        paddingBottom = _ref.paddingBottom,
        paddingInlineEnd = _ref.paddingInlineEnd,
        _ref$detailsTextColor = _ref.detailsTextColor,
        detailsTextColor = _ref$detailsTextColor === undefined ? _colors2.default.D20 : _ref$detailsTextColor;

    var styles = (0, _ReservationDetails2.default)(i18n.getDir() === 'rtl', fontFamily, titleFontFamily, titlePaddingBottom, paddingBottom, paddingInlineEnd);

    function I18N() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return i18n.get.apply(i18n, ['reservations_details_' + args[0], args[1]].concat((0, _toConsumableArray3.default)(args.slice(2))));
    }

    function renderCol(title, value) {
        var titleHook = title.replace(' ', '-').toLowerCase();
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { style: styles.tdTitle },
                title
            ),
            _react2.default.createElement(
                'div',
                { style: styles.tdValue, 'data-hook': titleHook },
                value
            )
        );
    }

    function renderRow(col1, col2, first) {
        var style = (0, _extends3.default)({}, styles.firstCol, first ? styles.outerTd : styles.innerTd);

        return _react2.default.createElement(
            TR,
            { style: styles.tr },
            _react2.default.createElement(
                TD,
                { style: style },
                col1
            ),
            _react2.default.createElement(
                TD,
                { style: style },
                col2
            )
        );
    }

    function renderSpecialRequest() {
        return _react2.default.createElement(
            TR,
            { style: styles.tr },
            _react2.default.createElement(
                TD,
                { colSpan: 2, style: (0, _extends3.default)({}, styles.tdTitle, styles.innerTd) },
                _react2.default.createElement(
                    'div',
                    { style: styles.tdTitle },
                    I18N('special_request', 'SPECIAL REQUEST:')
                ),
                _react2.default.createElement(
                    'div',
                    { style: (0, _extends3.default)({}, styles.tdComments, { color: detailsTextColor }), 'data-hook': 'special-request' },
                    reservation.comment
                )
            )
        );
    }

    function getHeldTimeTxt() {
        return _momentTimezone2.default.duration((0, _momentTimezone2.default)(reservation.heldUntil).diff((0, _momentTimezone2.default)(reservation.time))).humanize();
    }

    function getPartySizeValueText() {
        var singular = reservation.partySize === 1;

        return singular ? i18n.get('reservations_app_party_size_option_single', '1 person') : i18n.get('reservations_app_party_size_option_plural', '${params.count} people', {
            params: {
                count: reservation.partySize
            }
        });
    }

    function renderRows() {
        var date = _LocaleUtils2.default.getFormattedAppointedDate((0, _momentTimezone2.default)(reservation.time).tz(restaurant.timezone));
        var time = (0, _momentTimezone2.default)(reservation.time).tz(restaurant.timezone).format('LT');
        var heldFor = getHeldTimeTxt();

        var col1 = renderCol(I18N('date_title', 'DATE'), date),
            col2 = renderCol(I18N('time_title', 'TIME'), time),
            col3 = renderCol(I18N('partysize_title', 'PARTY SIZE'), getPartySizeValueText()),
            col4 = renderCol(I18N('heldfor_title', 'HELD FOR'), heldFor);

        var row1 = renderRow(col1, col2, true),
            row2 = renderRow(col3, col4);

        return { row1: row1, row2: row2, row3: row3 };
    }

    var _renderRows = renderRows(),
        row1 = _renderRows.row1,
        row2 = _renderRows.row2,
        row3 = _renderRows.row3;

    return _react2.default.createElement(
        Table,
        { style: (0, _extends3.default)({}, styles.table, { color: detailsTextColor }) },
        _react2.default.createElement(
            TBody,
            null,
            row1,
            row2,
            row3,
            reservation.comment && renderSpecialRequest()
        )
    );
}

ReservationDetails.propTypes = {
    i18n: _propTypes2.default.object,
    reservation: _propTypes2.default.object,
    restaurant: _propTypes2.default.object,
    detailsTextColor: _propTypes2.default.string,
    fontFamily: _propTypes2.default.string,
    titleFontFamily: _propTypes2.default.string,
    titlePaddingBottom: _propTypes2.default.number,
    paddingBottom: _propTypes2.default.number,
    paddingInlineEnd: _propTypes2.default.number
};

ReservationDetails.displayName = 'ReservationDetails';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationDetails.js
// module id = 388
// module chunks = 0